/**
 * News & Insights Block JavaScript
 */

(function () {
  "use strict";

  function getAjaxUrl(resultsEl) {
    const dataUrl = resultsEl.dataset.ajaxUrl;
    if (dataUrl) {
      return dataUrl;
    }
    if (window.sojTheme && window.sojTheme.ajaxUrl) {
      return window.sojTheme.ajaxUrl;
    }
    return "/wp-admin/admin-ajax.php";
  }

  function initNewsInsights() {
    const blocks = document.querySelectorAll(".news-insights");

    blocks.forEach((block) => {
      const results = block.querySelector("[data-news-results]");
      const listContainer = results
        ? results.querySelector("[data-news-list-container]")
        : null;
      const pagination = results
        ? results.querySelector("[data-news-pagination]")
        : null;
      const emptyMessage = results
        ? results.querySelector("[data-empty-message]")
        : null;
      const plantingSelect = block.querySelector(
        '[data-news-filter="planting"]'
      );
      const sectorSelect = block.querySelector('[data-news-filter="sector"]');
      const clearFiltersLink = block.querySelector("[data-news-clear-filters]");

      if (!results || !listContainer) {
        return;
      }

      const ajaxUrl = getAjaxUrl(results);
      const nonce = results.dataset.nonce;
      const action = results.dataset.action || "soj_filter_news_insights";

      const setEmptyState = (hasResults) => {
        if (!emptyMessage) {
          return;
        }
        emptyMessage.classList.toggle("is-hidden", !!hasResults);
      };

      const setPagination = (html) => {
        if (!pagination) {
          return;
        }
        if (html) {
          pagination.innerHTML = html;
          pagination.classList.remove("is-hidden");
        } else {
          pagination.innerHTML = "";
          pagination.classList.add("is-hidden");
        }
      };

      const updateClearFiltersVisibility = () => {
        if (!clearFiltersLink) return;
        const plantingValue = plantingSelect ? plantingSelect.value : "";
        const sectorValue = sectorSelect ? sectorSelect.value : "";
        const hasFilter = !!plantingValue || !!sectorValue;
        clearFiltersLink.classList.toggle("is-hidden", !hasFilter);
        clearFiltersLink.setAttribute("aria-hidden", hasFilter ? "false" : "true");
      };

      const fetchResults = (page = 1) => {
        const plantingValue = plantingSelect ? plantingSelect.value : "";
        const sectorValue = sectorSelect ? sectorSelect.value : "";

        if (!nonce) {
          console.error("[BLOCK] news-insights: Missing nonce. The block may not have loaded correctly.");
          return;
        }

        const formData = new FormData();
        formData.append("action", action);
        formData.append("nonce", nonce);
        formData.append("planting", plantingValue);
        formData.append("sector", sectorValue);
        formData.append("page", page);

        results.classList.add("is-loading");

        fetch(ajaxUrl, {
          method: "POST",
          credentials: "same-origin",
          body: formData,
        })
          .then(async (response) => {
            const text = await response.text();
            if (!response.ok) {
              if (response.status === 400) {
                console.error("[BLOCK] news-insights: 400 Bad Request. Response:", text.substring(0, 200));
              }
              throw new Error(
                `Network response was not ok (${response.status})`
              );
            }
            try {
              return JSON.parse(text);
            } catch (e) {
              throw new Error("Invalid JSON response: " + text.substring(0, 100));
            }
          })
          .then((data) => {
            if (!data || !data.success) {
              const errorMsg = data?.data?.message || data?.data || "Unexpected response";
              if (typeof errorMsg === "string" && errorMsg.includes("refresh")) {
                listContainer.innerHTML = `<p class="news-insights__error">${errorMsg}</p>`;
                setPagination("");
                return;
              }
              throw new Error(errorMsg);
            }

            const html = data.data.html || "";
            listContainer.innerHTML = html;
            setEmptyState(Boolean(data.data.found && html.trim().length > 0));
            setPagination(data.data.pagination || "");
            results.dataset.currentPage = page;
            updateClearFiltersVisibility();
            
            // Scroll to top of the page
            // Use smooth scroll if available (Lenis), otherwise use native smooth scroll
            const smoothScroll = window.SOJ_SMOOTH_SCROLL;
            if (smoothScroll && typeof smoothScroll.scrollToTop === 'function') {
              smoothScroll.scrollToTop();
            } else {
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }
          })
          .catch((error) => {
            console.error("[BLOCK] news-insights filter error:", error);
            listContainer.innerHTML = "";
            setEmptyState(false);
            setPagination("");
          })
          .finally(() => {
            results.classList.remove("is-loading");
          });
      };

      const handleFilterChange = () => {
        updateClearFiltersVisibility();
        fetchResults(1);
      };

      const handlePaginationClick = (event) => {
        if (!pagination) {
          return;
        }

        const link = event.target.closest("a");
        if (!link) {
          return;
        }

        event.preventDefault();

        let page = 1;
        const href = link.getAttribute("href");
        if (href) {
          try {
            const url = new URL(href, window.location.origin);
            page =
              parseInt(url.searchParams.get("ni-page"), 10) ||
              parseInt(url.searchParams.get("paged"), 10) ||
              1;
          } catch (error) {
            page = 1;
          }
        }

        fetchResults(page);
      };

      if (plantingSelect) {
        plantingSelect.addEventListener("change", handleFilterChange);
      }

      if (sectorSelect) {
        sectorSelect.addEventListener("change", handleFilterChange);
      }

      if (clearFiltersLink) {
        updateClearFiltersVisibility();
      }

      if (pagination) {
        pagination.addEventListener("click", handlePaginationClick);
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initNewsInsights);
  } else {
    initNewsInsights();
  }
})();